import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { sleep } from '../../../smoothr-web-app-core/utils/utils';

type ModalState = 'form' | 'success';

@Component({
	selector: 'app-invoice-email-modal',
	standalone: false,
	templateUrl: './invoice-email-modal.component.html',
	styleUrls: ['./invoice-email-modal.component.scss'],
})
export class InvoiceEmailModalComponent {
	state: ModalState = 'form';
	email = '';

	private modalCtrl: ModalController = inject(ModalController);

	constructor() {}

	static async show(modalCtrl: ModalController): Promise<string> {
		const modal = await modalCtrl.create({
			component: InvoiceEmailModalComponent,
		});

		await modal.present();
		return (await modal.onDidDismiss()).data ?? '';
	}

	async send() {
		if (!this.email) return;
		this.state = 'success';
		await sleep(2000);
		this.done();
	}

	close() {
		this.modalCtrl.dismiss();
	}

	done() {
		this.modalCtrl.dismiss(this.email);
	}
}
